import router from "../../../router/index";

export default {
  onResize(context) {
    context.commit("onResize");
    context.dispatch("calcSideBarWidth");
    context.dispatch("changeBodyPadding", context.getters.isSmallScreen);
    context.dispatch("changeNavBarWidth", context.getters.isSmallScreen);
  },

  calcSideBarWidth(context) {
    if (!context.getters.isSmallScreen) {
      const drawerEl = document.querySelector(".fullScreen .main_sidebar");
      const sideBarWidth =
        drawerEl && drawerEl.clientWidth > 0 ? drawerEl.clientWidth : 270;
      context.commit("calcSideBarWidth", sideBarWidth);
    } else {
      context.commit("calcSideBarWidth", 0);
    }
  },

  changeBodyPadding(context, payload) {
    let lang = context.rootGetters["lang_module/lang"];
    const body = document.querySelector("body");
    if (!body) return;

    body.style.paddingTop = "100px";

    if (router.app && router.app._route && router.app._route.name == "Login") {
      body.style.padding = "0";
      body.style.marginInlineStart = "0px";
      body.style.marginInlineEnd = "0px";
    } else {
      if (payload == false) {
        if (lang == "ar") {
          body.style.paddingLeft = "20px";
          body.style.paddingRight = "0px";
        } else {
          body.style.paddingRight = "20px";
          body.style.paddingLeft = "0px";
        }
        const width = context.getters.sideBarWidth || 270;
        body.style.marginInlineStart = width + 20 + "px";
        body.style.marginInlineEnd = "0px";
      } else {
        body.style.paddingLeft = "0px";
        body.style.paddingRight = "0px";
        body.style.marginInlineStart = "0px";
        body.style.marginInlineEnd = "0px";
      }
    }
  },

  changeNavBarWidth(context, payload) {
    const navbar = document.querySelector(".main_nav");
    if (!navbar) return;

    if (payload == false) {
      const width = context.getters.sideBarWidth || 270;
      navbar.style.width = `calc(100% - ${width + 30}px)`;
    } else {
      navbar.style.width = `calc(100% - 20px)`;
    }
  },

  // ============> No mutations
  reseatBodyPadding() {
    const body = document.querySelector("body");
    body.style.padding = "0";
  },

  disableNavSide() {
    const sideBar = document.querySelector(".main_sidebar");
    sideBar.style.display = "none";

    const navbar = document.querySelector(".main_nav");
    navbar.style.display = "none";
  },
};
